const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/customisation/global-styles/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
// Extend input props to include webkitdirectory
interface DirectoryInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  webkitdirectory?: string;
}
export const Route = createFileRoute('/dash/settings/customisation/global-styles/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});